import { Grid, Typography } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useGetAllMeetingsQuery } from "../../../redux/Hire/candidateMeetingApi";
import {
  useGetInterviewQuery,
  useLazyQuestionnaireQuery,
} from "../../../redux/Hire/interviewQuestionSlice";
import {
  CandidateDetails,
  JobRequestDetails,
} from "../../../redux/Hire/jobRequestApi";
import { HiringStageCode } from "../../../utils/constants";
import CandidateSummary from "./CandidateSummary";
import QuestionsList from "./QuestionsList";

type Props = {
  candidate?: CandidateDetails;
  job?: JobRequestDetails;
};

const ScreeningTab = ({ candidate, job }: Props) => {
  const [pollingInterval, setPollingInterval] = useState<number | undefined>(
    5000,
  );

  const { data: allMeetingsRound1 } = useGetAllMeetingsQuery({
    candidateId: candidate?.id.toString() || "",
    candidateStage: HiringStageCode.SHORTLIST,
  });
  const { data: interviewData, isError } = useGetInterviewQuery(
    {
      candidateId: candidate?.id.toString() || "",
      jobId: job?.jobId.toString() || "",
    },
    {
      pollingInterval: pollingInterval,
      skip: !candidate?.id || !job?.jobId,
      refetchOnMountOrArgChange: true,
    },
  );

  const meetingData = useMemo(() => {
    return interviewData?.meetings.find(
      (el) => el.link === allMeetingsRound1?.data[0]?.link,
    );
  }, [allMeetingsRound1, interviewData]);

  const [getQuestionnaire] = useLazyQuestionnaireQuery();

  useEffect(() => {
    if (
      (interviewData?.questionGenerationStatus === "FAILED" ||
        interviewData?.questionGenerationStatus === "PENDING") &&
      candidate?.id &&
      job?.jobId
    ) {
      getQuestionnaire({
        jobId: job?.jobId.toString() || "",
        candidateId: candidate?.id.toString() || "",
      });
    }
    if (interviewData?.questionGenerationStatus === "COMPLETED") {
      setPollingInterval(0);
    }
  }, [candidate?.id, getQuestionnaire, interviewData, job]);

  useEffect(() => {
    if (isError) {
      setPollingInterval(0);
    }
  }, [isError]);
  return (
    <Grid container item direction={"column"} gap={2} wrap="nowrap">
      <Grid item width={"100%"}>
        <CandidateSummary
          candidate={candidate}
          meeting={allMeetingsRound1?.data[0]}
          jobId={job?.jobId}
        />
      </Grid>
      <Grid item>
        {interviewData?.questionGenerationStatus &&
          interviewData?.questionGenerationStatus === "IN_PROCESS" && (
            <Grid
              container
              direction="column"
              alignItems="center"
              justifyContent="center"
              sx={{ minHeight: 120 }}
            >
              <Grid item>
                {/* Animated SVG: spinner ring */}
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  style={{ display: "block" }}
                >
                  <circle
                    cx="24"
                    cy="24"
                    r="20"
                    fill="none"
                    stroke="#7B61FF"
                    strokeWidth="5"
                    strokeDasharray="31.4 94.2"
                    strokeLinecap="round"
                  >
                    <animateTransform
                      attributeName="transform"
                      type="rotate"
                      from="0 24 24"
                      to="360 24 24"
                      dur="0.9s"
                      repeatCount="indefinite"
                    />
                  </circle>
                </svg>
              </Grid>
              <Grid item>
                <Typography
                  variant="body2"
                  color="textSecondary"
                  sx={{ mt: 2, fontWeight: 500, letterSpacing: 0.2 }}
                >
                  Questions generation in process...
                </Typography>
              </Grid>
            </Grid>
          )}
        {interviewData?.questionGenerationStatus &&
          interviewData?.questionGenerationStatus === "COMPLETED" && (
            <QuestionsList
              interviewId={interviewData._id || ""}
              meetingId={meetingData?.meetingId || ""}
              questions={interviewData?.questions || []}
              hideSubmit={typeof interviewData.draftSummary !== "undefined"}
            />
          )}
      </Grid>
    </Grid>
  );
};

export default ScreeningTab;
